import axios from 'axios'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const POLICY_TEMPLATES_URL = `${ROOT}/secure/policy/template`

export function fetchPolicyTemplatesList({ customerId, policyType }) {
  return axios.get(POLICY_TEMPLATES_URL, { params: { customerId, policyType } })
}

export function fetchPolicyTemplate({ templateId }) {
  return axios.get(`${POLICY_TEMPLATES_URL}/${templateId}`)
}

export function deletePolicyTemplate({ templateId }) {
  return axios.delete(`${POLICY_TEMPLATES_URL}/${templateId}`)
}

export function updatePolicyTemplate({ templateId, data }) {
  return axios.put(`${POLICY_TEMPLATES_URL}/${templateId}`, data)
}

export function createPolicyTemplate({ organizationId, data }) {
  return axios.post(POLICY_TEMPLATES_URL, {
    ...data,
    organizationId,
    customerId: null,
  })
}
